import CreateNewCardModal from './CreateNewCardModal';

export default CreateNewCardModal;
